<template>
  <section style="min-height: 95vh; overflow-y: auto;overflow-x: hidden" v-infinite-scroll="InfinitePostData"
    infinite-scroll-disabled="postInfiniteDisabled" infinite-scroll-delay="500" infinite-scroll-immediate="true"
    infinite-scroll-distance="0" class="profile_container_common" ref="profile">
    <b-row>
      <b-col sm="12">
        <iq-card class="iq-card">
          <div class="cover-container">
            <el-image style="width: 100%" :src="backImg" class="img-fluid" >
              <div slot="error" class="image-slot">
                <el-skeleton >
                  <template slot="template">
                    <el-skeleton-item variant="image" style="width: 100%; height:180px" />
                  </template>
                </el-skeleton>
              </div>
            </el-image>
          </div>
          <!-- icon -->
          <b-row>
            <b-col sm="12" class="d-flex justify-content-end">
              <ul class="profile-icon-box d-flex flex-wrap justify-end p-0 m-0">
                <!-- <li>
                  <router-link to="/wallet" style="line-height: 45px"
                    ><i class="las la-wallet"></i
                  ></router-link>
                </li> -->
                  <!-- 分享 -->
                <li>
                  <a href="javascript:;" @click="shareModal">
                    <svg t="1718262022207" class="iconShare1" viewBox="0 0 1422 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42689" width="20" height="20"><path d="M1193.784889 20.622222a108.828444 108.828444 0 0 1 108.657778 103.224889l0.170666 5.603556v85.105777a36.266667 36.266667 0 0 1-72.362666 3.697778l-0.199111-3.697778V129.422222c0-18.773333-14.279111-34.247111-32.568889-36.124444l-3.697778-0.170667H129.450667c-18.773333 0-34.247111 14.279111-36.124445 32.568889l-0.170666 3.697778v765.155555c0 18.773333 14.279111 34.218667 32.568888 36.067556l3.697778 0.199111H1193.813333c18.773333 0 34.218667-14.279111 36.096-32.568889l0.170667-3.697778v-140.231111a36.266667 36.266667 0 0 1 72.362667-3.697778l0.199111 3.697778v140.231111a108.828444 108.828444 0 0 1-103.253334 108.657778l-5.575111 0.142222H129.450667A108.828444 108.828444 0 0 1 20.764444 900.152889l-0.142222-5.603556V129.450667A108.828444 108.828444 0 0 1 123.847111 20.764444L129.422222 20.622222h1064.334222z m29.895111 306.688l3.612444 0.853334 148.280889 43.605333c17.607111 5.176889 28.387556 22.584889 25.6 40.334222l-0.711111 3.555556-38.968889 150.698666a36.266667 36.266667 0 0 1-70.997333-14.535111l0.739556-3.640889 18.119111-70.257777c-191.345778 81.408-267.747556 198.912-238.506667 357.688888a36.266667 36.266667 0 1 1-71.338667 13.141334c-35.441778-192.284444 57.543111-338.090667 270.023111-432.526222l-62.691555-18.460445a36.266667 36.266667 0 0 1-25.457778-41.415111l0.853333-3.612444a36.266667 36.266667 0 0 1 41.443556-25.429334zM411.648 194.616889c96.853333 0 175.160889 79.445333 175.160889 177.152a177.578667 177.578667 0 0 1-75.150222 145.464889c95.857778 36.181333 169.415111 119.665778 169.415111 202.922666 0 55.409778-33.28 90.254222-89.912889 105.699556a269.653333 269.653333 0 0 1-9.557333 2.417778l-9.841778 2.104889-10.24 1.820444-10.837334 1.564445-11.52 1.308444-12.344888 1.052444-13.340445 0.853334-14.449778 0.682666-24.064 0.654223-27.363555 0.341333h-71.964445l-27.363555-0.341333-24.092445-0.654223-14.478222-0.682666-13.340444-0.853334-12.373334-1.052444-11.548444-1.308444-10.808889-1.536c-3.527111-0.568889-6.940444-1.166222-10.296889-1.820445l-9.841778-2.133333a270.193778 270.193778 0 0 1-9.585777-2.417778C175.104 810.410667 141.767111 775.424 142.222222 719.872c0.711111-83.228444 73.955556-166.485333 169.443556-202.638222a177.493333 177.493333 0 0 1-75.150222-145.464889c0-97.706667 78.307556-177.152 175.132444-177.152z m0 376.405333c-101.575111 0-196.295111 81.123556-196.864 149.447111-0.142222 16.896 9.415111 28.16 35.754667 35.271111l7.594666 1.848889 4.096 0.853334 8.903111 1.536 4.807112 0.711111 10.268444 1.251555c3.584 0.398222 7.338667 0.768 11.235556 1.080889l12.231111 0.910222 13.255111 0.768 14.279111 0.568889 23.495111 0.597334 26.055111 0.284444 40.504889 0.028445 18.204444-0.085334 17.066667-0.227555 23.466667-0.568889 14.307555-0.597334 13.226667-0.768 12.231111-0.910222 11.207111-1.080889 10.24-1.28 9.386667-1.422222c2.958222-0.540444 5.774222-1.080889 8.448-1.678222l7.594667-1.820445c26.282667-7.168 35.896889-18.488889 35.896888-35.555555 0-67.868444-95.118222-149.162667-196.892444-149.162667z m479.857778 7.822222a36.266667 36.266667 0 0 1 3.697778 72.362667l-3.697778 0.199111h-160.227556a36.266667 36.266667 0 0 1-3.697778-72.362666l3.697778-0.199112h160.199111zM411.619556 267.178667c-56.519111 0-102.570667 46.705778-102.570667 104.590222 0 57.912889 46.051556 104.618667 102.570667 104.618667 56.547556 0 102.599111-46.705778 102.599111-104.618667 0-57.884444-46.051556-104.590222-102.599111-104.590222z m645.404444 41.728a36.266667 36.266667 0 0 1 3.697778 72.362666l-3.697778 0.170667H731.306667a36.266667 36.266667 0 0 1-3.697778-72.362667l3.697778-0.170666h325.802666z" fill="#22A2F2" p-id="42690"></path></svg>
                    <svg t="1718250931069" class="iconShare2" viewBox="0 0 1422 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42441" width="20" height="20"><path d="M1193.784889 20.622222a108.828444 108.828444 0 0 1 108.657778 103.224889l0.170666 5.603556v85.105777a36.266667 36.266667 0 0 1-72.362666 3.697778l-0.199111-3.697778V129.422222c0-18.773333-14.279111-34.247111-32.568889-36.124444l-3.697778-0.170667H129.450667c-18.773333 0-34.247111 14.279111-36.124445 32.568889l-0.170666 3.697778v765.155555c0 18.773333 14.279111 34.218667 32.568888 36.067556l3.697778 0.199111H1193.813333c18.773333 0 34.218667-14.279111 36.096-32.568889l0.170667-3.697778v-140.231111a36.266667 36.266667 0 0 1 72.362667-3.697778l0.199111 3.697778v140.231111a108.828444 108.828444 0 0 1-103.253334 108.657778l-5.575111 0.142222H129.450667A108.828444 108.828444 0 0 1 20.764444 900.152889l-0.142222-5.603556V129.450667A108.828444 108.828444 0 0 1 123.847111 20.764444L129.422222 20.622222h1064.334222z m29.895111 306.688l3.612444 0.853334 148.280889 43.605333c17.607111 5.176889 28.387556 22.584889 25.6 40.334222l-0.711111 3.555556-38.968889 150.698666a36.266667 36.266667 0 0 1-70.997333-14.535111l0.739556-3.640889 18.119111-70.257777c-191.345778 81.408-267.747556 198.912-238.506667 357.688888a36.266667 36.266667 0 1 1-71.338667 13.141334c-35.441778-192.284444 57.543111-338.090667 270.023111-432.526222l-62.691555-18.460445a36.266667 36.266667 0 0 1-25.457778-41.415111l0.853333-3.612444a36.266667 36.266667 0 0 1 41.443556-25.429334zM411.648 194.616889c96.853333 0 175.160889 79.445333 175.160889 177.152a177.578667 177.578667 0 0 1-75.150222 145.464889c95.857778 36.181333 169.415111 119.665778 169.415111 202.922666 0 55.409778-33.28 90.254222-89.912889 105.699556a269.653333 269.653333 0 0 1-9.557333 2.417778l-9.841778 2.104889-10.24 1.820444-10.837334 1.564445-11.52 1.308444-12.344888 1.052444-13.340445 0.853334-14.449778 0.682666-24.064 0.654223-27.363555 0.341333h-71.964445l-27.363555-0.341333-24.092445-0.654223-14.478222-0.682666-13.340444-0.853334-12.373334-1.052444-11.548444-1.308444-10.808889-1.536c-3.527111-0.568889-6.940444-1.166222-10.296889-1.820445l-9.841778-2.133333a270.193778 270.193778 0 0 1-9.585777-2.417778C175.104 810.410667 141.767111 775.424 142.222222 719.872c0.711111-83.228444 73.955556-166.485333 169.443556-202.638222a177.493333 177.493333 0 0 1-75.150222-145.464889c0-97.706667 78.307556-177.152 175.132444-177.152z m0 376.405333c-101.575111 0-196.295111 81.123556-196.864 149.447111-0.142222 16.896 9.415111 28.16 35.754667 35.271111l7.594666 1.848889 4.096 0.853334 8.903111 1.536 4.807112 0.711111 10.268444 1.251555c3.584 0.398222 7.338667 0.768 11.235556 1.080889l12.231111 0.910222 13.255111 0.768 14.279111 0.568889 23.495111 0.597334 26.055111 0.284444 40.504889 0.028445 18.204444-0.085334 17.066667-0.227555 23.466667-0.568889 14.307555-0.597334 13.226667-0.768 12.231111-0.910222 11.207111-1.080889 10.24-1.28 9.386667-1.422222c2.958222-0.540444 5.774222-1.080889 8.448-1.678222l7.594667-1.820445c26.282667-7.168 35.896889-18.488889 35.896888-35.555555 0-67.868444-95.118222-149.162667-196.892444-149.162667z m479.857778 7.822222a36.266667 36.266667 0 0 1 3.697778 72.362667l-3.697778 0.199111h-160.227556a36.266667 36.266667 0 0 1-3.697778-72.362666l3.697778-0.199112h160.199111zM411.619556 267.178667c-56.519111 0-102.570667 46.705778-102.570667 104.590222 0 57.912889 46.051556 104.618667 102.570667 104.618667 56.547556 0 102.599111-46.705778 102.599111-104.618667 0-57.884444-46.051556-104.590222-102.599111-104.590222z m645.404444 41.728a36.266667 36.266667 0 0 1 3.697778 72.362666l-3.697778 0.170667H731.306667a36.266667 36.266667 0 0 1-3.697778-72.362667l3.697778-0.170666h325.802666z" fill="#ffffff" p-id="42442"></path></svg>
                  </a>
                </li>
                <li v-if="isHideIcon">
                  <!-- 弹窗 -->
                  <router-link to="#" v-b-modal.editPersonalInformation @click.native="childEdit"
                    ><i class="ri-pencil-line"></i></router-link>
                </li>
                <!-- Setting -->
                <li v-if="isHideIcon">
                  <router-link to="/settings"><i class="ri-settings-4-line"></i></router-link>
                </li>
              </ul>
              <!-- 编辑弹窗 -->
              <EditProfile ref="child" class="editProfile" @getNewUserInfo="getNewUserInfo" :list="user_info"></EditProfile>
            </b-col>
          </b-row>

          <b-row class="space-box">
            <!-- avatar -->
            <b-col sm="12" md="12" lg="8">
              <div class="user-info">
                <el-skeleton v-if="loading" animated>
                  <template slot="template">
                    <el-skeleton-item class="avatarImg" variant="circle"  />
                    <el-skeleton-item class="nickName" variant="text" />
                  </template>
                </el-skeleton>
                <div v-else>
                  <div class="avatar-box">
                    <img style="object-fit: cover" :src="newInfo.avatar" @click="childEdit" />
                  </div>

                  <div class="flow-data">
                    <h3 class="title">
                      {{ newInfo.nick_name ? newInfo.nick_name : " " }}
                    </h3>
                  </div>
                </div>
              </div>
            </b-col>
            <!-- button -->
            <b-col sm="12" md="12" lg="4" class="btns">
              <ul class="btn-box list-inline m-0" v-if="!isHideIcon">
                <!-- <li class="text-center">
                  <b-button v-if="!is_block" pill variant="primary" @click="pullBlack" style="width: 88px;">Block
                  </b-button>
                  <b-button v-else pill variant="secondary" @click="closePullBlack" style="width: 88px;">Block
                  </b-button>
                </li> -->
                <li class="text-center mr-2">
                  <b-button v-if="is_friend == false" pill variant="primary" @click="friendRequest"><i
                      class="ri-add-line"></i>{{ $t("MyJCI.d4a@friend") }}</b-button>
                  <b-button v-else pill variant="secondary" @click="confirmDel"><i class="ri-check-line"></i>{{
                    $t("MyJCI.69d@my_friend") }}
                  </b-button>
                </li>
                <li class="text-center">
                  <b-button class="chatBtn" pill @click="handleClickChatItem()"><i class="ri-message-2-line"></i>{{
                    $t("MyJCI.b93@chat") }}
                  </b-button>
                </li>
              </ul>
            </b-col>
            <b-col sm="12" class="relative_col">
              <ul class="slogan mb-0" v-if="
                  this.isHideIcon == true || user_privacy.account_privacy != 1
                ">
                <li class="pl-1 d-flex user_motto">
                  <i class="ri-file-list-line mr-2"></i>
                  <span v-if="user_info.motto">{{ user_info.motto }}</span>
                  <span v-else>Add your personal bio here.</span>
                </li>
                <li v-if="titlelist.length">
                  <svg t="1610960158108" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="1527" width="18" height="18">
                    <path
                      d="M454.9632 224h114.0736l44.8-89.6H410.112l44.8 89.6z m-88.2688-153.6h290.6112a37.12 37.12 0 0 1 33.2288 53.76l-66.048 131.9936c-9.728 19.5072-29.696 31.8464-51.5072 31.8464H451.0208c-21.8112 0-41.7792-12.288-51.5072-31.8464l-66.048-132.0448a37.12 37.12 0 0 1 33.2288-53.7088zM282.5216 690.7904l116.48-326.144c8.192-22.9376 29.9008-38.2464 54.272-38.2464h117.504c24.32 0 46.08 15.3088 54.272 38.2464l116.4288 326.144c7.4752 20.992 2.2528 44.3392-13.5168 60.1088l-189.696 189.696a37.12 37.12 0 0 1-52.5312 0l-189.696-189.696a57.6 57.6 0 0 1-13.5168-60.1088z m61.6448 17.7152L512 876.3392l167.8336-167.8336-113.5616-318.1056H457.728l-113.5616 318.1056z"
                      fill="#5A5A68" p-id="1528"></path>
                  </svg>

                  <span v-if="titlelist.length < 1">
                    {{ $t("MyJCI.675@go_jci_career_to_inp") }}
                  </span>
                  <span v-else v-for="(item, index) in titlelist" :key="index">
                    {{ item.job_title }},
                  </span>
                </li>
              </ul>
              <div class="pcLeft">
                <span class="user_tag ml-3 member" v-if="user_info.is_member == 1">
                  {{ $t("MyJCI.42a@member") }}
                </span>
                <!-- <span
                  class="user_tag ml-4 member"
                  v-else-if="user_info.is_member == 2"
                >
                  {{ $t("MyJCI.d3a@alumni") }}
                </span> -->
                <span class="user_tag ml-3 member" v-else-if="user_info.is_member == 3">
                  {{ $t("MyJCI.a01@probationary_member") }}
                </span>
                <router-link class="user_tag tag" style="color: #999" v-else-if="user_info.is_member == 0 && isHideIcon"
                  to="/settings">
                  <i class="ri-add-line mr-2"></i>{{ $t("MyJCI.c8d@im_a_member") }}
                </router-link>

                <span class="user_tag seatorApply" v-if="user_senate == 1 && isHideIcon"><span class="applyText">{{
                    $t("MyJCI.7e2@senator") }}</span>
                  {{ $t("MyJCI.cb5@under_review") }}</span>
                <span class="user_tag seator" v-else-if="user_senate == 2">{{
                  $t("MyJCI.7e2@senator")
                  }} <span style="font-size:12px"> No.{{senate_number}}</span></span>
                <a class="user_tag tag" style="color: #999" href="javascript:;"
                  v-else-if="(user_senate == 0 || user_senate == 3) && isHideIcon" v-b-modal.Seator><i
                    class="ri-add-line mr-2"></i>{{ $t("MyJCI.d0a@im_a_senator") }}</a>
                <!-- <span class="user_tag tag" v-b-modal.foundation
                  ><i class="ri-add-line mr-2"></i> Foundation</span
                >
                <span class="user_tag foundation">
                  Foundation
                </span>
                <span class="user_tag foundApply">
                  <span class="applyText">Foundation</span>
                  under review</span
                > -->
                <span class="user_tag donor_level ml-3" v-if="donor_level">{{donor_level}}</span>
              </div>
              <div v-if="!isHideIcon" class="absolute_div">
                <b-dropdown id="dropdownMenuButton40" right variant="none" menu-class="p-0">
                  <template v-slot:button-content>
                    <i class="ri-more-fill" style="font-size: 20px;color:#777d74"></i>
                  </template>
                  <b-dropdown-item class="dropdown-item p-0" v-if="!is_block">
                    <h6 class="pt-2 pb-2" @click="pullBlack">Block</h6>
                  </b-dropdown-item>
                  <b-dropdown-item class="dropdown-item p-0" v-if="is_block" disabled>
                    <h6 class="pt-2 pb-2">Blocked</h6>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </b-col>
          </b-row>
        </iq-card>
        <b-modal id="foundation" centered :title="$t('MyJCI.f02@add_foundation_infor')" hide-footer>
          <div class="form-group">
            <label>{{ $t("MyJCI.ef7@donor_level") }}</label>
            <select class="form-control">
              <option>00</option>
            </select>
          </div>
          <button type="button" class="btn btn-primary mt-2 float-right">
            {{ $t("MyJCI.f2c@submit") }}
          </button>
        </b-modal>
        <el-dialog :visible.sync="shareUserDia" >
          <div slot="title" class="dialog-header">
            <span>Share Profile</span>
          </div>
          <div class="form-group">
            <label>URL</label>
            <input type="text" v-model="computedUserLink" class="form-control colorInt" disabled />
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary"  v-clipboard:copy="userLink" v-clipboard:success="copyUserLink">Copy link</el-button>
          </div>
        </el-dialog>
        <b-modal id="Seator" centered :title="$t('Senator.42a@application_form')" hide-footer>
          <div class="form-group">
            <label>{{ $t("MyJCI.327No") }}.</label>
            <input type="text" v-model="senateApply" class="form-control" @input="limitInput" />
          </div>
          <div class="form-group">
            <label>Senate Date</label>
            <el-date-picker v-model="created_at" type="date" style="width: 100%;" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
          <p>Your application will be submitted to JCI Staff for review. It will be pending approval until reviewed and passed. Once approved, the Senatorship will be displayed on your profile.</p>
          <hr />
          <button type="button" class="btn btn-primary mt-2 float-right" @click="getSenateApply">
            {{ $t("MyJCI.f2c@submit") }}
          </button>
        </b-modal>

        <!-- toggle -->
        <iq-card class="iq-card" v-if="isHideIcon == true || user_privacy.account_privacy != 1">
          <div class="user-tabing profile-feed-items">
            <tab-nav class="
                d-flex
                align-items-center
                justify-content-between
                tabsWidthScroll
                border-0
              " :tabs="true">
              <tab-nav-items class="col-sm-2 ml-sm-3 ml-md-0 p-0" :active="tabActive == 'timeline'" id="pills-feed-tab"
                href="#timeline" ariaControls="pills-home" role="tab" :ariaSelected="true" :title="Timeline"
                @click.native="tabActive='timeline'" />
              <tab-nav-items class="col-sm-2 p-0" :active="tabActive == 'about'" id="pills-activity-tab" href="#about"
                ariaControls="pills-profile" role="tab" :ariaSelected="false" :title="$t('MyJCI.f6d@about')"
                @click.native="tabActive='about',getAboutInfo()" />
              <tab-nav-items class="col-sm-2 p-0" :active="tabActive == 'projects'" id="pills-activity-tab" href="#projects"
                ariaControls="pills-profile" role="tab" :ariaSelected="false" title="My Projects"
                @click.native="tabActive='projects',getPorject()" v-if="isHideIcon"/>
              <tab-nav-items class="col-sm-2 p-0" :active="tabActive == 'friends'" id="pills-friend-tab" href="#friends"
                ariaControls="pills-contact" role="tab" :ariaSelected="false" :title="Friends"
                @click.native="tabActive='friends',userFriendList()" />
              <tab-nav-items class="col-sm-2 p-0" :active="tabActive == 'channel'" id="pills-profile-tab"
                href="#channel" ariaControls="pills-contact" role="tab" :ariaSelected="false" :title="Organizations"
                @click.native="channel(),tabActive='channel'" />
              <tab-nav-items class="col-sm-2 p-0" :active="tabActive == 'albums'" id="pills-profile-tab" href="#albums"
                ariaControls="pills-contact" role="tab" :ariaSelected="false" :title="$t('MyJCI.852@albums')"
                @click.native="album(),tabActive='albums'" />
            </tab-nav>
          </div>
        </iq-card>
      </b-col>

      <b-col sm="12" v-if="isHideIcon == true || user_privacy.account_privacy != 1">
        <div class="tab-content">
          <tab-content-item :active="tabActive == 'timeline'" id="timeline" aria-labelled-by="pills-feed-tab">
            <div class="iq-card-body p-0">
              <Timeline :photoList="photoList" :isHideIcon="isHideIcon"
                @toAllFriend="tabActive='friends',userFriendList()" @toMedia="tabActive='albums',album()" ref="timeLine"
                @fatherMethod='postInfiniteDisabled=true' />
            </div>
          </tab-content-item>
          <tab-content-item :active="tabActive == 'about'" id="about" aria-labelled-by="pills-activity-tab">
            <div class="iq-card">
              <div class="iq-card-body">
                <About :isHideIcon="isHideIcon" ref="aboutDet" />
              </div>
            </div>
          </tab-content-item>
          <tab-content-item :active="tabActive == 'projects'" id="projects" aria-labelled-by="pills-activity-tab">
            <div class="iq-card">
              <div class="iq-card-body">
                <Projects ref="projectDet" :isHideIcon="isHideIcon" />
              </div>
            </div>
          </tab-content-item>
          <tab-content-item :active="tabActive == 'friends'" id="friends" aria-labelled-by="pills-friend-tab">
            <div class="iq-card">
              <div class="iq-card-body">
                <h2>{{ $t("MyJCI.8e7@friends") }}</h2>
                <FriendTab :local="local" :national="national" :global="global" :other="other" :area="area"
                  :region="region" :isHideIcon="isHideIcon" />
              </div>
            </div>
          </tab-content-item>
          <tab-content-item :active="tabActive == 'channel'" id="channel" aria-labelled-by="pills-profile-tab">
            <div class="iq-card">
              <div class="iq-card-body">
                <h2 class="mb-3">Organizations</h2>
                <Channel :channel="channelList" :isHideIcon="isHideIcon" />
              </div>
            </div>
          </tab-content-item>
          <tab-content-item :active="tabActive == 'albums'" id="albums" aria-labelled-by="pills-profile-tab">
            <Meida ref="albums" :photoList="photoList" :isHideIcon="isHideIcon" />
          </tab-content-item>
        </div>
      </b-col>
    </b-row>

    <div v-if="isShowScrollNumber" @click="postListToTop" class="toTop">
      <i class="ri-upload-line"></i>
    </div>
  </section>
</template>
<script>
import Timeline from './components/Timeline'
import About from './components/About/About.vue'
import EditProfile from './components/EditProfile'
import FriendTab from './components/FriendTab'
import Channel from './components/Channel'
import Projects from './components/Projects'
import Meida from './components/Media/Media.vue'
import router from '../../router'
import {
  mapActions,
  mapMutations,
  mapGetters
} from 'vuex'
export default {
  components: {
    Timeline,
    About,
    FriendTab,
    Channel,
    Meida,
    Projects,
    EditProfile
  },
  data () {
    return {
      backImg:require('../../assets/images/page-img/JVCProfileCoverPhoto.jpg'),
      user_data_count: {
        posts_count: 0,
        friends_count: 0,
        follow_count: 0
      },
      user_info: {},
      user_title: '',
      isHideIcon: false,
      is_friend: '',
      is_block: '',
      user_senate: '',
      senate_number: '',
      donor_level: '',
      area: [],
      local: [],
      national: [],
      global: [],
      region: [],
      other: [],
      channelList: [],
      photoList: [],
      titlelist: [],
      senateApply: '',
      user_privacy: {},

      // see all friends 跳到friends
      tabActive: 'timeline',
      postInfiniteDisabled: false,
      isShowScrollNumber: 0,
      created_at: '',

      userLink: "",
      shareUserDia: false,

      newInfo: {},//优先显示昵称

      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      dataChat: 'ChatRoom/getDataChat'
    }),
    Timeline () {
      return 'Timeline' + '(' + this.user_data_count.posts_count + ')'
    },
    Friends () {
      return 'Friends' + '(' + this.user_data_count.friends_count + ')'
    },
    Organizations () {
      return 'Organizations' + '(' + this.user_data_count.follow_count + ')'
    },
    computedUserLink () {
      let selfId = JSON.parse(this.$getlocalStorage('userInfo')).user_id
      let router_id = parseInt(this.$route.query.user_id)
      let userUrl = `${window.location.href}${router_id ? '' : '?user_id=' + selfId}`
      return userUrl
    },
  },
  created () {
    this.getNewUserInfo()
  },
  mounted () {
    this.getUserInfo()
    this.getTitleList()
    this.getAllPhoto()
    this.myChannel()
    this.userFriendList()
    let postListContainer = this.$refs.profile
    postListContainer.addEventListener('scroll', (e) => {
      this.isShowScrollNumber = e.target.scrollTop
    })
  },
  methods: {
    getAboutInfo(){
      this.$refs.aboutDet.getUser();
    },
    getPorject(){
      this.$refs.projectDet.getProjectList();
    },
    getNewUserInfo(){
      let selfId = JSON.parse(this.$getlocalStorage('userInfo')).user_id
      let router_id = parseInt(this.$route.query.user_id)
      let id = ''
      if (router_id == selfId || !router_id) {
        id = selfId
        this.isHideIcon = true
      } else {
        id = router_id
        this.isHideIcon = false
      }
      this.loading = true
      // 如果没有传id，就自动获取自己的信息
      this.$http.getNewUserInfo({ user_id: id }).then((res) => {
        if (res.status == 200) {
          this.newInfo = res.data;
          this.loading = false
        }
      })
    
    },
    shareModal(){
      this.shareUserDia = true,
      this.userLink = this.computedUserLink;
    },
    copyUserLink (e) {
      this.$message.success('Copy Successfully')
    },
    // 限制No.
    limitInput () {
      if (/[^0-9]/g.test(this.senateApply)) {
        this.$message.warning('Only numbers can be entered')
      }
      this.senateApply = this.senateApply.replace(/[^0-9.]/g, '')
    },

    // 拉黑帖子作者
    pullBlack () {
      let user_name = this.user_info.nick_name ? this.user_info.nick_name : 'JVC USER'
      this.$confirm(`Are you sure you want to block ${user_name}?`, 'Tips',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(async () => {
        let res = await this.$http.pullBlack({ blacks_user_id: [this.$route.query.user_id] })
        if (res.status == 200) {
          this.is_block = true
          this.$message.success(res.message)
        }
      })
    },

    // 删除已拉黑用户
    closePullBlack (item) {
      this.$confirm('Are you sure you want to remove this post from the blocklist?', 'Tips',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(async () => {
        let res = await this.$http.closePullBlack({ blacks_user_id: [this.$route.query.user_id] })
        if (res.status == 200) {
          this.is_block = false
          this.$message.success(res.message)
        }
      })
    },

    postListToTop () {
      let postListContainer = this.$refs.profile
      let top = postListContainer.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        postListContainer.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    InfinitePostData () {
      this.$refs.timeLine.$emit('funInfinitePost')
    },
    // 议员申请
    getSenateApply () {
      // console.log('this.created_at', this.created_at);
      this.$http.getSenateApply({
        member_number: this.senateApply,
        created_at: this.created_at
      }).then((res) => {
        if (res.status == 200) {
          this.getUserInfo()
          this.$bvModal.hide('Seator')
        }
      })
    },
    // 职位
    getTitleList () {
      let selfId = JSON.parse(this.$getlocalStorage('userInfo')).user_id
      let router_id = parseInt(this.$route.query.user_id)
      let id = ''
      if (router_id == selfId || !router_id) {
        id = ''
      } else {
        id = router_id
      }
      this.$http
        .professionalTitlesList({
          user_id: id,
          out_time: '1'
        })
        .then((res) => {
          if (res.status == 200) {
            this.titlelist = res.data
            // console.log("职位",this.titlelist);
          }
        })
    },
    childEdit () {
      if(this.isHideIcon){
        this.$bvModal.show('editPersonalInformation')
      }
      this.$refs.child.asset()
    },
    ...mapMutations({
      CHANGE_DATA_CHAT: 'ChatRoom/CHANGE_DATA_CHAT',
      CHANGE_CURRENT_CHAT: 'ChatRoom/CHANGE_CURRENT_CHAT'
    }),
    ...mapActions({
      modeChange: 'Setting/layoutModeAction'
    }),
    async handleClickChatItem () {
      await this.$http
        .getUserInfo({
          user_id: this.$route.query.user_id
        })
        .then((res) => {
          // console.log(this.$route.query.user_id);
          this.$router.push('/chat')
          const list = res.data.user_info
          this.CHANGE_CURRENT_CHAT({
            ...list,
            isSidebar: true
          })
        })
    },
    getUserFriend () {
      let client_id = this.dataChat.client_id
      const params = {
        client_id,
        type: 'getUserFriend'
      }
      const res = this.$http.getUserFriend(params)
      if (res.status == 200) {
        this.friendsList = JSON.parse(JSON.stringify(res.data))
        this.friendsList.forEach((v, i) => {
          this.$set(v, 'select', false)
        })
      }
    },
    channel () {
      this.myChannel()
    },
    album () {
      this.$refs.albums.getAlbum()
      this.getAllPhoto()
      // this.getVideo();
    },
    // 获取相册
    // getAlbum () {
    //   let selfId = JSON.parse(this.$getlocalStorage("userInfo")).user_id;
    //   let router_id = parseInt(this.$route.query.user_id);
    //   let id = "";
    //   if (router_id == selfId || !router_id) {
    //     id = selfId;
    //   } else {
    //     id = router_id;
    //   }
    //   let albumId = id;
    //   this.$http
    //     .getAllAlbums({
    //       model_type: 1,
    //       model_id: albumId,
    //       per_page: 9,
    //     })
    //     .then((res) => {
    //       if (res.status == 200) {
    //         this.albumList = res.data.data;
    //         console.log("alum",this.albumList);
    //       }
    //     });
    // },
    // 获取相片
    getAllPhoto () {
      let selfId = JSON.parse(this.$getlocalStorage('userInfo')).user_id
      let router_id = parseInt(this.$route.query.user_id)
      let id = ''
      if (router_id == selfId || !router_id) {
        id = selfId
      } else {
        id = router_id
      }
      let photoId = id
      this.$http
        .getAllPhoto({
          model_type: 1,
          model_id: photoId,
          per_page: 9
        })
        .then((res) => {
          if (res.status == 200) {
            this.photoList = res.data.data
            // console.log("photo",this.photoList);
          }
        })
    },

    // 获取我的频道列表
    myChannel () {
      let selfId = JSON.parse(this.$getlocalStorage('userInfo')).user_id
      let router_id = parseInt(this.$route.query.user_id)
      let id = ''
      if (router_id == selfId || !router_id) {
        id = selfId
      } else {
        id = router_id
      }
      this.$http.myChannel({
        user_id: id
      }).then((res) => {
        if (res.status == 200) {
          this.channelList = res.data.data
          this.user_data_count.follow_count = res.data.total
          // console.log('channel', res.data)
        }
      })
    },
    // 获取好友
    // 获取好友列表  -> 先获取个人ID然后获取好友列表
    userFriendList () {
      let selfId = JSON.parse(this.$getlocalStorage('userInfo')).user_id
      let router_id = parseInt(this.$route.query.user_id)
      let id = ''
      if (router_id == selfId || !router_id) {
        id = selfId
      } else {
        id = router_id
      }
      this.$http
        .userFriendList({
          user_id: id
        })
        .then((res) => {
          // console.log('friendtab', res.data);
          if (res.status == 200) {
            this.user_data_count.friends_count = res.data.total.length
            if (res.data.other) {
              this.other = res.data.other
            }
            if (res.data.local) {
              this.local = res.data.local
            }
            if (res.data.national) {
              this.national = res.data.national
            }
            if (res.data.global) {
              this.global = res.data.global
            }
            if (res.data.regional) {
              this.region = res.data.regional
            }
            if (res.data.area) {
              this.area = res.data.area
            }
          }
        })
    },
    // 获取用户信息
    getUserInfo () {
      let selfId = JSON.parse(this.$getlocalStorage('userInfo')).user_id
      let router_id = parseInt(this.$route.query.user_id)
      let id = ''
      if (router_id == selfId || !router_id) {
        id = selfId
        this.isHideIcon = true
      } else {
        id = router_id
        this.isHideIcon = false
      }
      // 如果没有传id，就自动获取自己的信息
      this.$http.getUserInfo({ user_id: id }).then((res) => {
        if (res.status == 200) {
          // console.log('res.data', res.data);
          // if(router_id == selfId || !router_id){
          //   let userInfo = res.data.user_info;
          // this.$setlocalStorage("userInfo", JSON.stringify(userInfo));
          // this.$store.commit("Public/USEREINFO", userInfo);
          // }
          if (res.data.user_data_count != null) {
            this.user_data_count.posts_count =
                res.data.user_data_count.posts_count
            // this.user_data_count.friends_count =
            //   res.data.user_data_count.friends_count;
            // this.user_data_count.follow_count =
            //   res.data.user_data_count.follow_count;
          } else {
            this.user_data_count.posts_count = 0
            this.user_data_count.friends_count = 0
            this.user_data_count.follow_count = 0
          }
          this.user_privacy = res.data.user_privacy
          this.user_info = res.data.user_info
          // console.log("info", res.data);
          this.is_friend = res.data.is_friend
          this.is_block = res.data.is_block
          this.user_title = res.data.user_info.user_title
          this.user_senate = res.data.user_senate
          this.senate_number = res.data.member_number
          this.donor_level = res.data.donor_level
        }
      })
    },
    // 发送好友申请
    friendRequest () {
      let selfId = JSON.parse(this.$getlocalStorage('userInfo')).user_id
      let router_id = parseInt(this.$route.query.user_id)
      let id = ''
      if (router_id == selfId || !router_id) {
        id = selfId
      } else {
        id = router_id
      }
      this.$http.friendRequest({
        user_id: id
      }).then((res) => {
        if (res.status == 200) {
          // console.log(res);
        }
      })
    },

    // 删除好友
    delFriend () {
      this.$http.delFriend({
        user_id: this.$route.query.user_id
      }).then((res) => {
        if (res.status == 200) {
          this.getUserInfo()
          this.$bus.$emit('updateFriend')
        }
      })
    },
    // 删除好友关系时询问
    confirmDel () {
      this.$confirm('Are you sure you want to delete?', 'Tips', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.delFriend()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Deletion cancelled'
          })
        })
    }
  },

  destroyed () {
    // console.log("bus.$off('editPost'----pro)");
    // this.$bus.$off('editPost')
  }

}

</script>
<style lang="scss" scoped>
  /deep/ #Seator {
    .modal-dialog.modal-md.modal-dialog-centered {
      max-width: 760px;
    }
  }

  .absolute_div {
    position: absolute;
    bottom: 0;
    right: 0;

    /deep/ .dropdown-toggle::after {
      display: none;
    }
  }

  // icon(不需要响应式)
  .cover-container {
    position: relative;
  }

  .editProfile {
    display: none;
  }

  .img-fluid {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .chatBtn {
    background: #fff !important;
    color: #50b5ff !important;
    border-color: #50b5ff !important;
  }
  ::v-deep .el-dialog__header{
    padding: 15px;
    border-bottom: 1px solid #f1f1f1;
    .dialog-header{
      color: #333;
      font-size: 16px;
      font-weight: 400;
    }
  }
  ::v-deep .el-dialog__footer{
    padding: 0px !important;
    border-top: 1px solid #f1f1f1;
    .dialog-footer{
      margin: 10px;
      padding-bottom: 10px;
    }
  }
  .colorInt{
    color: #50b5ff !important;
    font-size: 14px;
    font-weight: 300;
  }
  

  // pc
  @media (min-width: 992px) {
    ::v-deep .el-dialog {
      width: 45%;
    }
    .space-box {
      height: 200px;
    }
    .relative_col {
      position: relative;

      .user_motto {
        max-height:46px;
        // overflow: auto;
        // :nth-child(2){
        //   max-width: 300px;
        //   display: inline-block;
        //   overflow: hidden;
        //   white-space: nowrap;
        //   text-overflow: ellipsis;
        //   -webkit-box-orient: vertical;
        //   -webkit-line-clamp: 1; //行数
        // }
        
      }
    }
    // icon-circle
    .profile-icon-box {
      position: absolute;
      left: auto;
      right: 0;
      top: auto;
      bottom: 20px;

      li {
        list-style: none;

        a {
          display: block;
          list-style: none;
          height: 40px;
          width: 40px;
          line-height: 40px;
          background: var(--iq-white);
          border-radius: 50%;
          text-align: center;
          color: var(--iq-primary);
          font-size: 18px;
          margin: 0 1.071429rem 0 0;
          svg:last-child {
            display: none;
          }
        }

        a:hover {
          background-color: #50b5ff;
          color: var(--iq-white);
          svg:first-child {
            display: none;
          }
          svg:last-child {
            display: inline-block;
          }
        }
      }
    }
    
    .avatar-box {
      background: url("../../assets/images/public/user.png");
      background-size: 100%;
    }

    // avatar-block
    .user-info {
      position: relative;
      height: 70px;

      .avatarImg {
        width: 140px; 
        height: 140px;
        position: absolute;
        top: -60px;
        left: 40px;
      }
      .nickName {
        width: 200px;
        position: absolute;
        height:30px;
        top: 10px;
        left: 200px;
      }

      .avatar-box {
        width: 140px;
        height: 140px;
        border-radius: 50%;
        overflow: hidden;
        position: absolute;
        top: -60px;
        left: 30px;

        img {
          display: block;
          width: 100%;
          // height: 100%;
        }
      }

      .flow-data {
        position: absolute;
        top: 0;
        left: 190px;
        .title {
          margin-top: 1rem;
          width: 70vh;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .user_tag {
      // width: 120px;
      height: 35px;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      padding: 6px 10px;
      margin: 0 15px;
      box-sizing: border-box;
      text-align: center;
      border: 1px solid #999;
      border-top-left-radius: 1rem 50%;
      border-top-right-radius: 1rem 50%;
      border-bottom-right-radius: 1rem 50%;
      border-bottom-left-radius: 1rem 50%;
      font-size: 14px;
      color: #999;
    }

    .tag {
      padding: 5px 10px;
    }

    .member {
      border: 0;
      background: #4066b1;
      color: #fff;
    }

    .seatorApply {
      border: 0;
      background: rgba(85, 190, 164, 0.6);
      color: #fff;

      .applyText {
        color: rgba($color: #fff, $alpha: 0.5);
      }
    }

    .seator {
      border: 0;
      background: #55bea4;
      color: #fff;
    }

    .donor_level {
      border: 0;
      background: #EDBE38;
      color: #fff;
    }

    .foundation {
      border: 0;
      background: #edbf35;
      color: #fff;
    }

    .foundApply {
      border: 0;
      background: rgba(237, 191, 53, 0.6);
      color: #fff;

      .applyText {
        color: rgba($color: #fff, $alpha: 0.5);
      }
    }

    .btn-box {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px !important;
      margin-right: 15px !important;

      >li:nth-child(1) {
        margin-right: 10px;
      }
    }

    .slogan {
      padding-left: 30px;
      margin-top: 1rem;
    }
    .pcLeft {
      padding: 5px 20px 0;
    }
  }

  // 超小屏----test
  @media (max-width: 992px) {
    ::v-deep .el-dialog {
      width: 80%;
    }
    .space-box {
      height: 169px;
    }
    .relative_col {
      position: relative;

      .user_motto {
        max-height:46px;
        // overflow: auto;
        :nth-child(2){
          max-width: 300px;
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1; //行数
        }
        
      }
    }
    // icon-circle
    .profile-icon-box {
      position: absolute;
      left: auto;
      right: 0;
      top: auto;
      bottom: 5px;

      li {
        list-style: none;

        a {
          display: block;
          list-style: none;
          height: 30px;
          width: 30px;
          background: var(--iq-white);
          border-radius: 50%;
          line-height: 30px;
          text-align: center;
          color: var(--iq-primary);
          font-size: 18px;
          margin: 0 1.071429rem 0 0;
          svg:last-child {
            display: none;
          }
        }
      }
    }

    // avatar-block
    .user-info {
      position: relative;
      height: 45px;

      .avatarImg {
        width: 80px; 
        height: 80px;
        position: absolute;
        top: -25px;
        left: 20px;
      }
      .nickName {
        width: 150px;
        position: absolute;
        height: 20px;
        top: 10px;
        left: 115px;
      }

      .avatar-box {
        width: 75px;
        height: 75px;
        border-radius: 50%;
        overflow: hidden;
        position: absolute;
        top: -30px;
        left: 10px;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }

      .flow-data {
        position: absolute;
        top: 0;
        left: 93px;

        .title{
          margin-top: 5px;
          width: 70vh;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 18px;
        }

        .soicalInfo {
          li {
            margin-right: 12px !important;
            padding: 0 !important;
            font-size: 12px;

            p {
              margin-right: 7px !important;
            }

            h6 {
              font-size: 13px;
            }
          }
        }
      }
    }
  .user_tag {
      height: 28px;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      padding: 5px 6px;
      margin: 0 5px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      text-align: center;
      border: 1px solid #999;
      border-top-left-radius: 1rem 50%;
      border-top-right-radius: 1rem 50%;
      border-bottom-right-radius: 1rem 50%;
      border-bottom-left-radius: 1rem 50%;
      font-size: 10px;
      color: #999;
    }

    .tag {
      padding: 5px 10px;
    }

    .member {
      border: 0;
      background: #4066b1;
      color: #fff;
    }

    .seatorApply {
      border: 0;
      background: rgba(85, 190, 164, 0.6);
      color: #fff;

      .applyText {
        color: rgba($color: #fff, $alpha: 0.5);
      }
    }

    .seator {
      border: 0;
      background: #55bea4;
      color: #fff;
    }

    .donor_level {
      border: 0;
      background: #EDBE38;
      color: #fff;
    }

    .foundation {
      border: 0;
      background: #edbf35;
      color: #fff;
    }

    .foundApply {
      border: 0;
      background: rgba(237, 191, 53, 0.6);
      color: #fff;

      .applyText {
        color: rgba($color: #fff, $alpha: 0.5);
      }
    }
    .btn-box {
      display: flex;
      margin-left: 10px !important;

      >li:nth-child(1) {
        margin-right: 10px;
      }

      .btn {
        width: 90px;
        height: 30px;
        padding: 0;
        line-height: 30px;
        font-size: 14px;
      }
    }

    .slogan {
      margin-top: 8px;
      padding-left: 10px;
      font-size: 12px;
    }
    .pcLeft {
      padding-top: 5px;
    }
  }
</style>
